module.exports = ['/location', '/career', '/job']
